<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <div v-else>

        <b-row style="margin: 0 0 15px 0">
            <custom-multiselect v-model="userSelected" 
                                :options="options" 
                                :internal-search="false"
                                label="FullName"
                                placeholder="Выберите пользователя"
                                @search-change="changeUsers"
                                @select="getUserRoutes" />
            <a href="" name="audit"></a>
        </b-row>

        <b-row class="m-0">
            <b-col md="5" lg="3" sm="12" class="p-0">
                <div v-if="loadUserRoutes.Loading" class="container-tab-spinner">
                    <spinner />
                </div>
                <div v-else-if="!userRoutes.length && userSelected && !loadUserRoutes.Loading">
                    <div class="mb-15 center">
                        <font-awesome-icon icon="route" size="4x" color="#9d9d9d"/>
                    </div>
                    <div class="center stub-ladel">
                        У выбранного пользователя нет маршрутов
                    </div>
                </div>
                <b-list-group v-else>
                    <b-list-group-item button 
                                        v-for="(item, index) in userRoutes"
                                        :key="index"
                                        @click="getRoute(item)"
                                        class="wrap-name-property">

                        <div class="mb-5px"> <span> Дата: </span> {{ getDateString(item.RouteDate) }} </div>

                    </b-list-group-item>
                </b-list-group>
            </b-col>

            <b-col>
                <div v-if="loadRoute.Loading" class="container-tab-spinner">
                    <spinner />
                </div>
                <div v-else-if="route" class="wrap-name-property">                        
                    <div class="mb-5px"> <span> Дата: </span> {{ getDateString(route.RouteDate) }} </div>
                    <b-list-group >
                        <b-list-group-item button 
                                            v-for="(item, index) in routeTts"
                                            :key="index">

                            <div class="mb-5px"> <span></span> {{ item }} </div>

                        </b-list-group-item>
                    </b-list-group>
                </div>
                
            </b-col>

        </b-row>

    </div>
</template>

<script>
import '@/assets/styles/admin/audits/audits.css'

import apiService from '@/services/api.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import CustomMultiselect from '@/components/shared/CustomMultiSelect'


export default {
    data: function() {
        let load = new Loading();
        let loadUserRoutes = new Loading();
        let loadRoute = new Loading();

        this.getUsers(load);
        return {
            users: null,
            options: null,

            visibleAuditDax: false,

            load: load,
            loadUserRoutes: loadUserRoutes,
            loadRoute: loadRoute,

            userSelected: null,
            userRoutes: [],

            route: null,
        }
    },
    computed: {
        routeTts: function() {
            return JSON.parse(JSON.stringify(this.route.TradePointIds));
        }
    },
    methods: {
        getUsers: function(load) {
            load.Calculate(true);

            apiService.Admin.Audits.GetUsers()
                .then(response => {
                    this.users = response.data;
                    this.options = this.users;
                    load.Calculate(false);
                })
                .catch(exception => {
                    load.Calculate(false);
                });
        },

        getUserRoutes: function(user) {

            this.userRoutes = [];
            this.route = null;

            if(!user) 
                return;                      

            this.loadUserRoutes.Calculate(true);

            apiService.Admin.Users.GetUserRoutes(user.Id)
                .then(response => {
                    this.userRoutes = response.data;
                    this.loadUserRoutes.Calculate(false);
                })
                .catch(exception => {
                    console.log(exception);
                    this.loadUserRoutes.Calculate(false);
                });
        },

        getRoute: function(route) {
            this.route = route;      
        },
    
        changeUsers: function(value) {
            this.audit = null;
            this.auditDAX = null;

            if(value)
                this.options = this.users.filter(e => e.Dax.toLocaleLowerCase().includes(value.toLocaleLowerCase()) || 
                                                      e.Id.toLocaleLowerCase().includes(value.toLocaleLowerCase()) || 
                                                      e.FullName.toLocaleLowerCase().includes(value.toLocaleLowerCase()) ||
                                                      e.Email.toLocaleLowerCase().includes(value.toLocaleLowerCase()));
            else    
                this.options = this.users;
        },

        getDateString(value) {
            var value = new Date(value);
            const date = `${value.getDate()}`.length == 1
                            ? `0${value.getDate()}`
                            : value.getDate();

            const month = `${value.getMonth() + 1}`.length == 1
                            ? `0${value.getMonth() + 1}`
                            : value.getMonth() + 1;

            const year = value.getFullYear();

            return `${date}.${month}.${year}`;
        },

    },
    components: {
        Spinner,
        CustomMultiselect
    }
    
}
</script>